import React from "react";
import { Box } from "@mui/material";
import { DesignSurface, OriginalDesignSurface } from "./DesignSurface.js";
import { designTokens } from "./tokens.js";
import type { InterfaceColorMode } from "../../../util/src/design/tokens.js";

/** Fixed-size composition controls keep their labels in their original field slots. */
export function CompositionDesignSurface({
  active,
  color,
  children,
}: {
  active: boolean;
  color: InterfaceColorMode;
  children: React.ReactNode;
}) {
  const p = designTokens[color];
  return (
    <OriginalDesignSurface>
      <DesignSurface
        modeOverride={active ? "modern" : "original"}
        colorModeOverride={color}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            ...(active
              ? {
                  color: p.text,
                  "& .MuiInputLabel-root, & .MuiInputLabel-root.MuiInputLabel-shrink":
                    {
                      position: "absolute",
                      transform: "translate(9px, -7px)",
                      margin: 0,
                      px: "4px",
                      maxWidth: "calc(100% - 24px)",
                      fontSize: "10px",
                      lineHeight: "14px",
                      zIndex: 1,
                      bgcolor: p.surface,
                    },
                }
              : {}),
          }}
        >
          {children}
        </Box>
      </DesignSurface>
    </OriginalDesignSurface>
  );
}
